/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'
import Table from '../../../../components/InternalMenu/FoodList'

import { useNavigate } from 'react-router-dom'

import { get } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { ToastContainer } from 'react-toastify'

import foodIcon from '../../../../assets/svg/foodIcon.svg'

export default function index() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate()
  document.title = 'غذا یا نوشیدنی'

  const [foods, setFoods] = useState([])
  const [foodsCount, setFoodsCount] = useState()
  const [shops, setShops] = useState()
  const [selectShop, setSelectShop] = useState()
  const [categories, setCategories] = useState()
  const [categorySelect, setCategorySelect] = useState('all')
  const [name, setName] = useState()

  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/im/foods/create')
  }

  useEffect(() => {
    get(`/api/admin/im/foods?token=${token}`)
      .then(respose => {
        setFoodsCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get(`/api/front/im/shops?token=${token}`)
      .then(response => {
        setShops(response.data.data)
      })
      .catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const shopHandler = (e) => {
    setSelectShop(e.target.value)
    if (e.target.value.length >= 3) {
      get(`/api/front/im/categories/${e.target.value}?token=${token}`)
        .then(response => {
          setCategories(response.data.data)
        })
        .catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  }

  const categoryHandler = (e) => {
    setCategorySelect(e.target.id)
    if(e.target.id.length >= 3) {
      get(`/api/front/im/foods/cat/${e.target.id}?token=${token}`)
      .then(respose => {
        setFoods(respose.data.data[0].data)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
    }
  }

  const searchBtnHandler = () => {
    get(`/api/admin/im/foods/search/${name}?token=${token}`)
    .then(response => {
      setFoods(response.data.data[0].data)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'food'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست غذاها یا نوشیدنی‌ها
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler}>ایجاد غذا یا نوشیدنی</button>
            </div>
          </div>

          <div className="tablePart">
            <div className='search'>
              <label htmlFor="search">نام غذا یا نوشیدنی : </label>
              <input type="text" onChange={e => setName(e.target.value)}/>
              <button onClick={searchBtnHandler} style={{ margin: '0 0 0 1em' }}>جستجو</button>
            </div>
            <hr />
            <div className="title">
              <div className="right">
                تعداد کل غذاها یا نوشیدنی‌ها
              </div>
              <div className="left">
                {foodsCount}
              </div>
            </div>
            <hr />
            فست فود یا رستوران را انتخاب کنید : 
            <select onChange={shopHandler} name="" id="" className='selectInput'>
              <option value="">انتخاب کنید</option>
              {shops ? shops.map(item => {
                return <option value={item._id}>{item.name}</option>
              }) : ''}
            </select>
            <hr />
            <div className="categoriesSection">
              <div className="categoriesPart">
                {categories ? categories.map((item) => {
                return <div style={categorySelect === item._id ? { backgroundColor: '#f1c40f' } : {}} onClick={categoryHandler} className='categoriesButton' id={item._id}>{item.title}</div>
                }) : ''}
            </div>
            </div>
            <Table data={foods} shop={selectShop}/>

          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
